var map = {
	"./buhler.png": 4294,
	"./helvetia.png": 6798,
	"./kantonsspital-right.png": 3930,
	"./leica.png": 3888,
	"./logistic_zentrum.png": 444,
	"./mobiliar.png": 7347,
	"./omega.png": 159,
	"./post-finance.png": 9399,
	"./rolex.png": 8318,
	"./undefined.png": 3982
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2003;